// URL deep links (legacy: snapshot L2794-2830 size/sheet, L9429-9440 auth,
// L8839-8850 post-signup checkout). 662 marketing pages link to
// /editor/?sheet=<id> and /editor/?size=<id>; pricing/invite pages use
// ?plan=pro|business, ?signup, ?login=<ctx>, ?email=. ?continue forces the
// autosave restore even when a size link is present.
import { state, getCanvas } from './state'
import { applySizeById } from './panels/sizePicker'
import { fitToView, refreshGrid } from './canvas'
import { resetHistory } from './history'
import { trackEvent } from './analytics'
import { openAuth } from './auth/auth-ui'

export interface DeepLink {
  sheet: string | null
  size: string | null
  continue: boolean
  plan: 'pro' | 'business' | null
  signup: boolean
  login: string | null
  email: string | null
}

export function readDeepLink(search = typeof location !== 'undefined' ? location.search : ''): DeepLink {
  const p = new URLSearchParams(search)
  const plan = p.get('plan')
  return {
    sheet: p.get('sheet'),
    size: p.get('size'),
    continue: p.has('continue'),
    plan: plan === 'pro' || plan === 'business' ? plan : null,
    signup: p.has('signup'),
    login: p.get('login'),
    email: p.get('email'),
  }
}

/** The ?plan= value, read at call time (checkout fires after an async signup). */
export function pendingPlan(): 'pro' | 'business' | null {
  return readDeepLink().plan
}

/**
 * ?sheet= / ?size= → select that catalogue entry on a blank canvas. Returns
 * true when a link was consumed (boot then skips the autosave restore unless
 * ?continue is also present): the link promised "the editor at THIS size".
 */
export function applySizeDeepLink(link = readDeepLink()): boolean {
  const id = link.sheet ?? link.size
  if (!id) return false
  const kind = link.sheet ? 'sheet' : 'size'
  if (!applySizeById(id)) {
    trackEvent('deeplink_miss', { kind, id })
    return false
  }
  const c = getCanvas()
  c.clear()
  c.backgroundColor = '#ffffff'
  refreshGrid()
  c.requestRenderAll()
  fitToView()
  resetHistory()
  trackEvent(kind === 'sheet' ? 'deeplink_sheet' : 'deeplink_size', { [kind === 'sheet' ? 'sheet_id' : 'size_id']: id })
  return true
}

/** ?plan= / ?signup → sign-up tab; ?login= → sign-in tab (signed-out users only). */
export function applyAuthDeepLink(link = readDeepLink()): void {
  if (state.currentUser) return
  const opts = link.email ? { email: link.email } : {}
  if (link.plan || link.signup) openAuth('signup', opts)
  else if (link.login) openAuth('signin', opts)
}
